import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function ReturnToList({ onClickHandler, title, marginInlineStart = 4 }) {
  const { t } = useTranslation("translation");

  return (
    <Button
      color={"esg_blue"}
      textDecoration="underline"
      fontWeight="bold"
      marginInlineStart={marginInlineStart}
      variant="link"
      title={title}
      onClick={() => onClickHandler()}
    >
      {t("returnToList")}
    </Button>
  );
}

export default ReturnToList;